export const dialogModes = {
  add: 'ADD',
  update: 'UPDATE',
};

export const parameterInitialState = {
  name: '',
  importance: '',
};

export const getNewAreaParam = (areaId, parameter) => ({
  parameter,
  area: areaId,
  importance: parameter.importance,
});

export const therapeuticAreaInitialState = categoryId => ({
  name: '',
  parameters: [],
  category: categoryId.id,
});

export const categoryInitialState = {
  name: '',
  // therapeuticAreas: [],
};

export const csvData = {
  headers: [
    {
      label: 'HCP Number',
    },
    {
      label: 'HCP Name',
    },
  ],
  data: [],
};

export const getNewUser = () => ({ userName: '', password: '' });

export const baseURL = 'https://ranking.allotltd.com/api/';



// WEBPACK FOOTER //
// ./src/Constants.js